<template>
	<div id="app">
		<BhLoading :show="loading" />
		<LibrarySelector />
		<router-view />
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import MediaSelector from 'bh-mod/components/file/MediaSelector'
import LibrarySelector from 'bh-mod/components/file/LibrarySelector'
import BhLoading from 'bh-mod/components/common/Loading'

export default {
	name: 'app',
	components: { MediaSelector, LibrarySelector, BhLoading },
	computed: {
		...mapGetters(['user']),
		loading() {
			return this.$store.state.loading
		},
	},
	watch: {
		'$route'(to, from) {
			const query = Object.assign({}, to.query)
			this.$store.commit('SETUP_URL_SETTINGS', query)
		},
	},
	methods: {

	}
}
</script>
<style lang="scss">
#app {
	min-height: 100vh;
}

.table-card .ant-card-body {
	padding: 0;

	.ant-table-pagination.ant-pagination {
		margin-right: 2rem !important;
	}
}


body .ant-tabs-left-bar .ant-tabs-nav .ant-tabs-tab:last-child {
	margin-right: 16px !important;
}

.ant-card.borderless {
	.ant-card-head {
		border-bottom: 0;
	}
}

.link {
	color: var(--primary);
	cursor: pointer;
}

.badge-offer {
	padding: .35rem .65rem;
	text-align: center;
	display: inline-block;
	border-radius: .2rem;
	background: #aaa;
}

.bg-green {
	background-color: var(--green);
	color: white;
}

.bg-pink {
	background-color: #FD6C83;
	color: white;
}

.bg-dark-green {
	background-color: #419E00;
	color: white;
}

.bg-teal {
	background-color: #134F5C;
	color: white;
}
</style>
